import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Bell, CalendarCheck, CalendarClock, CalendarPlus, Check, ClipboardList, Truck } from "lucide-react";
import { api, errMsg } from "../../lib/api";

const ICONS = { followup: CalendarClock, meeting_done: CalendarCheck, meeting_move: CalendarPlus, task: ClipboardList, nudge: Bell, uid_next: Truck };
const today = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata" }).format(new Date());

const Status = ({ a }) => (
  <p data-testid={`lucy-action-status-${a.action_id}`} className={`mt-1.5 text-[11px] font-medium ${a.status === "done" ? "text-emerald-700" : "text-slate-500"}`}>
    {a.status === "done" ? <>Done via Lucy{a.link && <Link to={a.link} className="underline ml-1.5" data-testid={`lucy-action-open-${a.action_id}`}>Open</Link>}</> : a.status === "dismissed" ? "Dismissed" : "This suggestion has expired"}
  </p>
);

export const ActionCard = ({ a }) => {
  const [st, setSt] = useState(a);
  const [day, setDay] = useState(a.date || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setSt(a); setDay(a.date || ""); }, [a]);
  const go = (verb) => {
    setBusy(true);
    api.post(`/lucy/actions/${a.action_id}/${verb}`, verb === "confirm" ? { date: day || null } : {})
      .then((r) => { setSt(r.data); if (verb === "confirm") toast.success("Done. It's in the audit log as via Lucy."); })
      .catch((e) => { toast.error(errMsg(e)); setSt((s) => ({ ...s, error: errMsg(e) })); }).finally(() => setBusy(false));
  };
  const Icon = ICONS[a.type] || Check;
  return (
    <div data-testid={`lucy-action-${a.action_id}`} className="border border-violet-200 bg-white rounded-sm px-2.5 py-2 text-xs ax-fade">
      <div className="flex gap-2 items-start"><Icon className="h-3.5 w-3.5 text-violet-600 mt-0.5 shrink-0" /><span className="text-slate-800 leading-snug" data-testid={`lucy-action-label-${a.action_id}`}>{st.label}</span></div>
      {st.status === "proposed" ? (
        <div className="flex flex-wrap items-center gap-2 mt-2">
          {a.date && <input type="date" min={today()} value={day} onChange={(e) => setDay(e.target.value)} disabled={busy} data-testid={`lucy-action-date-${a.action_id}`} className="h-7 border border-slate-300 px-1.5 rounded-sm" />}
          <button type="button" data-testid={`lucy-action-confirm-${a.action_id}`} disabled={busy} onClick={() => go("confirm")}
            className="h-7 px-3 bg-violet-600 text-white rounded-sm hover:bg-violet-700 disabled:opacity-50 inline-flex items-center transition-colors"><Check className="h-3.5 w-3.5 mr-1" />Confirm</button>
          <button type="button" data-testid={`lucy-action-dismiss-${a.action_id}`} disabled={busy} onClick={() => go("dismiss")} className="h-7 px-2 text-slate-500 hover:text-slate-800 transition-colors">Dismiss</button>
          {st.error && <span className="basis-full text-[11px] text-amber-700" data-testid={`lucy-action-error-${a.action_id}`}>{st.error}</span>}
        </div>
      ) : <Status a={st} />}
    </div>
  );
};

export const ActionList = ({ items, tid = "lucy-actions" }) => (items?.length ? (
  <div className="space-y-1.5 mt-1.5" data-testid={tid}>{items.map((a) => <ActionCard key={a.action_id} a={a} />)}</div>
) : null);
